/*
 * @Description: 路由
 * @Date: 2025-07-16 15:29:41
 */
export const route = [
  {
    path: '/project-person-manage',
    name: 'project-person-manage',
    meta: {
      title: '项目人员管理'
    },
    component: () => import('../views/project-person-manage-list.vue')
  }
];
